module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product"
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('airportProducts.headerTopText'))
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.headerTopSubText')))]), _vm._v(" "), _c('span', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left",
      "data-aos-delay": "150"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('airportProducts.headerText'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('router-link', {
    staticClass: "btn orange",
    attrs: {
      "to": "/products/airport/presentation",
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('component.watchPresentation'))), _c('span')])], 1)]), _vm._v(" "), _c('a', {
    staticClass: "more-about-us white",
    attrs: {
      "data-scroll-offset": "120",
      "href": "#top",
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    },
    on: {
      "click": _vm.smoothScroll
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('component.moreAboutUs')))])])]), _vm._v(" "), _c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "top-text"
  }, [_c('p', {
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('airportProducts.whyOurSolutionText'))
    }
  }), _vm._v(" "), _c('h2', {
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.whyOurSolution')))])]), _vm._v(" "), _c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element right clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionOneTitle')))])]), _vm._v(" "), _c('ul', [_c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionOneText1')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionOneText2')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionOneText3')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "350"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionOneText4')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "400"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionOneText5')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "element left clearfix"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionTwoTitle')))])]), _vm._v(" "), _c('ul', [_c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionTwoText1')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionTwoText2')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionTwoText3')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "350"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionTwoText4')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "400"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionTwoText5')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "450"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionTwoText6')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "500"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionTwoText7')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "550"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionTwoText8')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "600"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionTwoText9')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "element right clearfix"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._m(5), _vm._v(" "), _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionThreeTitle')))])]), _vm._v(" "), _c('ul', [_c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionThreeText1')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionThreeText2')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionThreeText3')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "350"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionThreeText4')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "400"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionThreeText5')))])])])])])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "bottom-last"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', {
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.whyIShouldUseThis')))]), _vm._v(" "), _c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element"
  }, [_c('Counter', {
    attrs: {
      "data": _vm.circleValues[0]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "150"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('airportProducts.whyIShouldUseThisOneText')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "element"
  }, [_c('Counter', {
    attrs: {
      "data": _vm.circleValues[1]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('airportProducts.whyIShouldUseThisTwoText')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "element"
  }, [_c('Counter', {
    attrs: {
      "data": _vm.circleValues[2]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "350"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('airportProducts.whyIShouldUseThisThreeText')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "element"
  }, [_c('Counter', {
    attrs: {
      "data": _vm.circleValues[3]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "450"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('airportProducts.whyIShouldUseThisFourText')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('router-link', {
    staticClass: "btn orange",
    attrs: {
      "to": "/products/airport/presentation",
      "data-aos": "fade-up"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('component.watchPresentation'))), _c('span')])], 1)])]), _vm._v(" "), _c('footer-more-information', {
    attrs: {
      "modalpage": 'airport'
    }
  }), _vm._v(" "), _c('footer-main')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image",
    attrs: {
      "data-aos": "flip-left"
    }
  }, [_c('figure', {
    staticClass: "hexagon-image resizable",
    staticStyle: {
      "background-image": "url('/static/img/product/image1-airport.jpg')"
    }
  }, [_c('div', {
    staticClass: "hexTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "hexBottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }, [_c('span', [_vm._v("1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image",
    attrs: {
      "data-aos": "flip-right"
    }
  }, [_c('figure', {
    staticClass: "hexagon-image resizable",
    staticStyle: {
      "background-image": "url('/static/img/product/image2-airport.jpg')"
    }
  }, [_c('div', {
    staticClass: "hexTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "hexBottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }, [_c('span', [_vm._v("2")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image",
    attrs: {
      "data-aos": "flip-left"
    }
  }, [_c('figure', {
    staticClass: "hexagon-image resizable",
    staticStyle: {
      "background-image": "url('/static/img/product/image3-airport.jpg')"
    }
  }, [_c('div', {
    staticClass: "hexTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "hexBottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }, [_c('span', [_vm._v("3")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom-first orange-bg"
  }, [_c('div', {
    staticClass: "image-boxes inline-boxes"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "box",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/product/image-box-1.jpg",
      "alt": "team1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "150"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/product/image-box-2-airport.jpg",
      "alt": "team2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/product/image-box-5.jpg",
      "alt": "team3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/product/image-box-4-airport.jpg",
      "alt": "team4"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e000d14"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AirportProduct.vue
// module id = 305
// module chunks = 0